import { render, staticRenderFns } from "./ResponseAreaTable.vue?vue&type=template&id=faca1ede"
import script from "./ResponseAreaTable.vue?vue&type=script&lang=js"
export * from "./ResponseAreaTable.vue?vue&type=script&lang=js"
import style0 from "./ResponseAreaTable.vue?vue&type=style&index=0&id=faca1ede&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports